import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
// OBTIENER LISTADO DE BANCOS
export const getIngresosBodegaMantenimientoFecha = async(fechas) => {
    const result = await PrivateInterceptor(`Mantenimiento/Ingresos/listaIngresosFecha`, 'POST', fechas)
    return result;

}


export const getIngresosEncabezadoFechas = async (dates) => {
    
    const result = await PrivateInterceptor(`Mantenimiento/Ingresos/ingresosFechasEncabezado`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1]} );
    return result;

}

export const getIngresosDetallesFechas = async (dates) => {
    
    const result = await PrivateInterceptor(`Mantenimiento/Ingresos/ingresosDetallesFechas`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1]} );
    return result;

}